module.exports = __webpack_public_path__ + "static/img/banner-csr-10.188115e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-10.jpg
// module id = +j+F
// module chunks = 98